import * as types from "../actions/actionTypes";
import getUserIdentification from "../assets/getUserIdentification";
const initialState = {
  is_fetched: false,
  sharedContacts: [],
  userState: [],
  useStateLoading: false,
  showed_user: { name: "" },
  showLoading: true,
  updateLoading: false,

  loading: false,
  error: "",
  data: {},
  processing: false,
  transactionFormProcessing: false,
  paymentValidationProcessing: false,

  accountingSoftwareLoading: false,
  accountingSoftwareError: "",
  accountingSoftware: [],

  subAccountingSoftwareLoading: false,
  subAccountingSoftwareError: "",
  subAccountingSoftware: []
};

const ProjectSetting = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PROJECT_SOFTWARE_SETTING_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.GET_PROJECT_SOFTWARE_SETTING_SUCCESS:
      return { ...state, data: action.data, loading: false };
    case types.GET_PROJECT_SOFTWARE_SETTING_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.PROJECT_SOFTWARE_SETTING_STORE_REQUEST:
      return { ...state, processing: true };
    case types.PROJECT_SOFTWARE_SETTING_STORE_SUCCESS:
      return { ...state, data: action.data, processing: false };
    case types.PROJECT_SOFTWARE_SETTING_STORE_FAILURE:
      return { ...state, processing: false };

    case types.PROJECT_TRANSACTION_FORM_SETTING_STORE_REQUEST:
      return { ...state, transactionFormProcessing: true };
    case types.PROJECT_TRANSACTION_FORM_SETTING_STORE_SUCCESS:
      return {
        ...state,
        transactionFormProcessing: false
      };
    case types.PROJECT_TRANSACTION_FORM_SETTING_STORE_FAILURE:
      return { ...state, transactionFormProcessing: false };

    case types.PROJECT_PAYMENT_VALIDATION_SETTING_STORE_REQUEST:
      return { ...state, paymentValidationProcessing: true };
    case types.PROJECT_PAYMENT_VALIDATION_SETTING_STORE_SUCCESS:
      return {
        ...state,
        paymentValidationProcessing: false
      };
    case types.PROJECT_PAYMENT_VALIDATION_SETTING_STORE_FAILURE:
      return { ...state, paymentValidationProcessing: false };

    case types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_REQUEST:
      return {
        ...state,
        accountingSoftwareLoading: true,
        accountingSoftwareError: ""
      };
    case types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_SUCCESS:
      return {
        ...state,
        accountingSoftware: action.data,
        accountingSoftwareLoading: false
      };
    case types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_FAILURE:
      return {
        ...state,
        accountingSoftwareLoading: false,
        accountingSoftwareError: action.error
      };

    case types.PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_REQUEST:
      return {
        ...state,
        subAccountingSoftware: [],
        subAccountingSoftwareLoading: true,
        subAccountingSoftwareError: ""
      };
    case types.PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_SUCCESS:
      return {
        ...state,
        subAccountingSoftware: action.payLoad,
        subAccountingSoftwareLoading: false
      };
    case types.PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_FAILURE:
      return {
        ...state,
        subAccountingSoftwareLoading: false,
        subAccountingSoftwareError: action.error
      };

    case types.SHARED_CONTACTS_REQUEST:
      return { ...state, loading: true };
    case types.SHARED_CONTACTS_SUCCESS:
      return { ...state, sharedContacts: action.payLoad, loading: false };
    case types.SHARED_CONTACTS_FAILURE:
      return { ...state, loading: false };

    case types.SET_USER_STATE_REQUEST:
      return { ...state, useStateLoading: true };
    case types.SET_USER_STATE_SUCCESS:
      if (!Array.isArray(action.payLoad)) {
        return {
          ...state,
          showed_user: {
            ...action.payLoad,
            name: getUserIdentification(action.payLoad.user)
          },
          useStateLoading: false
        };
      } else {
        return { ...state, showed_user: [], useStateLoading: false };
      }
    case types.SET_USER_STATE_FAILURE:
      return { ...state, useStateLoading: false };

    case types.SHOW_USER_REQUEST:
      return { ...state, showLoading: true, showed_user: { name: "" } };
    case types.SHOW_USER_SUCCESS:
      if (!Array.isArray(action.payLoad)) {
        return {
          ...state,
          showed_user: {
            ...action.payLoad,
            name: getUserIdentification(action.payLoad.user)
          },
          showLoading: false
        };
      } else {
        return { ...state, showed_user: [], showLoading: false };
      }

    case types.SHOW_USER_FAILURE:
      return { ...state, showLoading: false };

    case types.UPDATE_USER_REQUEST:
      return { ...state, updateLoading: true };
    case types.UPDATE_USER_SUCCESS:
      return {
        ...state,
        showed_user: {
          ...action.payLoad,
          name: getUserIdentification(action.payLoad.user)
        },
        updateLoading: false
      };
    case types.UPDATE_USER_FAILURE:
      return { ...state, updateLoading: false };
    default:
      return state;
  }
};

export default ProjectSetting;
